import React, { useEffect, useState } from "react";
import "./index.scss";
import ApiCaller from "api/apiCaller";

type ExternalDashboardProps = {
  site:any;
};

const ExternalDashboard = ({ site }: ExternalDashboardProps) => {
  const [dashboards, setDashboards] = useState<Array<any>>([]);
  const getDashboards = async () => {
    const res:any = await ApiCaller.get('brand_external_dashboards/site');
    if (res.brand_external_dashboards) {
      const result:any = [];
      res.brand_external_dashboards.forEach((dashboard:any) => {
        dashboard.url = dashboard.url.replace('{{internal_code}}', site?.store?.internal_code);
        result.push(dashboard);
      });
      setDashboards(result);
    }
  };
  useEffect(() => {
    getDashboards();
  }, []);
  if (dashboards.length <= 0) {
    return (
      <h3>Tính năng này không có sẵn cho công ty bạn</h3>
    )
  }
  return (
    <div>
      {dashboards.map((dashboard, index) => (
        <div className="external-dashboard-tab__dashboard" key={index}>
          <h3>{dashboard.name}</h3>
          <iframe
            className="external-dashboard-tab__iframe"
            src={dashboard.url}
            frameBorder="0" 
            allowFullScreen
          />
        </div>
      ))}
    </div>
  );
};

export default ExternalDashboard;
